import { Segmented } from "antd";
import type { GlobalToken } from "antd";
import styled, { css } from "styled-components";
import { radius } from "@libertify/ui";

/**
 * The edit cards' pill toggle. theme-v2's default Segmented track picks up the
 * pale teal `colorBgLayout`; force a neutral fill so it reads as a plain toggle.
 * A wrapping track gets a fixed radius rather than a capsule so it stays clean
 * across lines.
 */
export const PillSegmented = styled(Segmented)<{
  $token: GlobalToken;
  /** Track width; without it the track hugs its pills. */
  $width?: string;
  /** Let the pills wrap onto more lines on a narrow container. */
  $wrap?: boolean;
}>`
  background: ${({ $token }) => $token.colorFillSecondary};
  border: 1px solid ${({ $token }) => $token.colorBorder};
  border-radius: ${({ $wrap }) => ($wrap ? radius.box : radius.pill)}px;
  padding: 4px;
  ${({ $width }) =>
    $width
      ? css`
          width: ${$width};
        `
      : css`
          align-self: flex-start;
          max-width: 100%;
        `}
  ${({ $wrap, $token }) =>
    $wrap
      ? css`
          .ant-segmented-group {
            flex-wrap: wrap;
            gap: 6px;
          }

          /* Across lines the sliding thumb stretches over every row. Hidden
             (its transitionend still ends the motion); the checked radio marks
             the pick, since -item-selected drops off while it slides. */
          .ant-segmented-thumb {
            visibility: hidden;
          }
          .ant-segmented-item:has(> .ant-segmented-item-input:checked) {
            background: ${$token.colorBgElevated};
            box-shadow: ${$token.boxShadowTertiary};
            color: ${$token.colorText};
          }
        `
      : null}
  .ant-segmented-item {
    border-radius: ${radius.pill}px;
    width: fit-content;
    padding: 7px 16px;
    font-weight: 500;
  }
  .ant-segmented-item-label {
    min-height: 0;
    line-height: normal;
    padding: 0;
  }
`;
